export default {
  "menu": {
    "biocompatibility": "Biocompatibilidade",
    "truckSleeps": "Eventos de Sonolência",
    "conduct": "Conduta",
    "sheetOfLife": "Folha de vida",
    "waitingTime": "Tempos limite",
    "assignment": "Atribuição",
    "manager": "Gerenciador",
    "dataManagement": "Gestão de dados",
    "compliance": "Observância",
    "ffdPvt": "Cognus",
    "ffdSleep": "Fitness for duty",
    "fleet": "Frota",
    "inspections": "Inspeções",
    "reports": "Relatórios"
  },
  "subMenu": {
    "summary": "Resumo",
    "detail": "Detalhe",
    "driver": "Condutor",
    "listOfVehicule": "Lista de atribuições",
    "drivers": "Motoristas",
    "pendingAssociationDrivers": "Motoristas Desconhecidos",
    "team": "Veículos",
    "pendingAssociationTeam": "Veículos desconhecidos",
    "semiTrailer": "Carretas",
    "pendingAssociationSemiTrailer": "Carretas desconhecidas",
    "geozone": "Geozonas",
    "tag": "Categorias",
    "extendedProperty": "Atributos adicionais",
    "configuration": "Configuração",
    "users": "Usuários",
    "driverList": "Lista de controle",
    "dynamicList": "Lista dinâmica",
    "workingShiftGroup": "Grupos de turnos",
    "results": "Resultados"
  },
  "taskManagerIndicators": {
    "open": "Desvios abertos",
    "overdue": "Desvios em atraso"
  },
  "actions": {
    "expand": "Expandir menu",
    "collapse": "Ocultar menu"
  },
  "reports": {
    "urlEmptyTitle": "Url não configurado",
    "urlEmpty": "Você não tem uma url configurada para visualizar os relatórios.<br>Entre em contato com o help desk da Gauss Control.",
    "invalidUrlTitle": "Url inválida",
    "invalidUrl": "O url <b>{externalUrl}</b> não é válido.<br>Entre em contato com o Help Desk da Gauss Control."
  }
};


// WEBPACK FOOTER //
// ./source/client/components/locales/language_configuration/portuguese/nav/index.js